import { logFormData } from 'shared/lib/logFormData';

import type { TCreditPurposeFormFields } from 'entities/creditForm';
import { sendStepsAnalyticsEvents, setCreditPurposeInfo } from 'entities/creditForm';

import { CreditPurposeInfoTexts } from 'features/UpdateCreditPurposeInfo/CreditPurposeInfo.texts';

export const submitCreditPurposeForm =
  (actualData: TCreditPurposeFormFields): ThunkResult<void> =>
  async (dispatch) => {
    dispatch(setCreditPurposeInfo({ data: actualData, isFullFilled: true }));
    logFormData('CreditPurposeInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([0], CreditPurposeInfoTexts, 'manual'));
  };
